"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TreeSet = _interopRequireDefault(require("../../../../java/util/TreeSet"));

var _CoordinateFilter = _interopRequireDefault(require("../geom/CoordinateFilter"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UniqueCoordinateArrayFilter =
/*#__PURE__*/
function () {
  function UniqueCoordinateArrayFilter() {
    _classCallCheck(this, UniqueCoordinateArrayFilter);

    UniqueCoordinateArrayFilter.constructor_.apply(this, arguments);
  }

  _createClass(UniqueCoordinateArrayFilter, [{
    key: "filter",
    value: function filter(coord) {
      if (!this.treeSet.contains(coord)) {
        this.list.add(coord);
        this.treeSet.add(coord);
      }
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      var coordinates = new Array(this.list.size()).fill(null);
      return this.list.toArray(coordinates);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return UniqueCoordinateArrayFilter;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_CoordinateFilter.default];
    }
  }], [{
    key: "filterCoordinates",
    value: function filterCoordinates(coords) {
      var filter = new UniqueCoordinateArrayFilter();

      for (var i = 0; i < coords.length; i++) {
        filter.filter(coords[i]);
      }

      return filter.getCoordinates();
    }
  }]);

  return UniqueCoordinateArrayFilter;
}();

exports.default = UniqueCoordinateArrayFilter;

UniqueCoordinateArrayFilter.constructor_ = function () {
  this.treeSet = new _TreeSet.default();
  this.list = new _ArrayList.default();
};